import { AxiosInstance, AxiosResponse } from 'axios'

export const contactConfirmation = (httpInstance: AxiosInstance) => ({
  getAuthorizationContact: async (url: string): Promise<AxiosResponse> => {
    const response = await httpInstance.post(url)
    return response
  }
})
